import { useEffect, useState } from "react";
import { get_suggestion_products_in_cart_query } from "@core/services/products";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import { minimize_str } from "@core/helpers/string";
import { product_card } from "@/gql-mockups/products";

/**
 * «خریداران این محصولات، ... هم خریده‌اند» برای سبد خرید.
 *
 * همان کارِ `useCart({ handle_suggestion_products: true })` هسته، ولی با کوئری
 * خود ژومنت: کوئری هسته روی واریانت فقط `price` و `details.count` را می‌گیرد،
 * پس محصول پیش‌فروش (موجودیِ صفر) روی کارت «ناموجود» می‌خورد. اینجا مدلِ کارت
 * ژومنت (`product_card`، با `presale` و `seo.full_url`) استفاده می‌شود.
 * هسته دست‌نخورده می‌ماند؛ سرویس هسته `gql` سفارشی را می‌پذیرد.
 */
const SUGGESTION_PRODUCTS_IN_CART_GQL = minimize_str(`
  query (
    $products: [SuggestionProductInput]
    $limit: Int
  ) {
    data: getSuggestionProducts(
      products: $products
      limit: $limit
    ) ${product_card}
  }
`);

const useCartSuggestions = ({ limit = 15 } = {}) => {
	const { cart } = useAuthContext();

	const [suggestion_products, set_suggestion_products] = useState([]);

	useEffect(() => {
		const products = (cart?.products || []).map(({ product_id, mix_variant_keys }) => ({
			product_id,
			mix_variant_keys,
		}));
		if (products.length === 0) return;

		get_suggestion_products_in_cart_query({ products, limit }, { gql: SUGGESTION_PRODUCTS_IN_CART_GQL })
			.then((data) => set_suggestion_products(data?.data))
			.catch(() => {});
	}, [cart?.products, limit]);

	return { suggestion_products };
};

export default useCartSuggestions;
